import * as React from "react"
import styled from "styled-components";

const StyledContentRoutes = styled.div`
    height: 100%;
    >:not(:first-child) {
        display:none;
        pointer-events:none;
    }
`
interface NavigationStackContext {
    concealed: boolean
}

export const NavigationStackContext = React.createContext<NavigationStackContext | undefined>(undefined);

export const NavigationStackUIStatePreserver: React.FC<{ url: string }> = props => {
    ///props.children is the currently rendered UI component
    const { url } = props;
    const previousNodes = React.useRef<{ url: string, children: typeof props.children }[]>([]);
    const toRender = React.useMemo(() => <div key={url}>
        {props.children}
    </div>, [props.children])
    React.useMemo(() => {
        //drop rendering any nodes that don't precede the current pattern
        previousNodes.current = [...previousNodes.current].filter(pn => {
            const ret = url.startsWith(pn.url) && pn.url !== url;
            return ret;
        })
        previousNodes.current.unshift({ url, children: toRender })
    }, [url, toRender]);

    const output = React.useMemo(() => (
        previousNodes.current.map(
            (v, idx) => (
                <NavigationStackContext.Provider key={v.url} value={{ concealed: idx !== 0 }}>
                    {v.children}
                </NavigationStackContext.Provider>
            )
        )
    ), [previousNodes.current])
    return <StyledContentRoutes>
        {
            output
        }
    </StyledContentRoutes>
}
